import { generateTypes } from '../utils/HttpReducerHelper';

const sseAccessToken = generateTypes('SSE', 'GET_ACCESS_TOKEN');

export { sseAccessToken };
